import React, { useState, useEffect } from 'react';
import { getApi } from '../../../api/endpoints.js';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import DetailsComponent from "../../../components/DetailsComponent.js";
import { selectQueryParams, updateQueryParams, resetQueryParams } from "../../../ui/customerListingReducer.js";
import { useSelector, useDispatch } from "react-redux";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ElectricityBillDetails from '../../../models/ElectricityBillDetails.js'

const PaymentModal = (props) => {
  const dispatch = useDispatch();
  const [ payPartnerBillApi ] = getApi('payPartnerBill')
  const [ paymentObj , setPaymentObj] = useState({});
  const selectedQueryParams = useSelector(selectQueryParams)
  const [ electricityBillDetails, setElectricityBillDetails ] = useState({})

  useEffect(()=>{
    setElectricityBillDetails(new ElectricityBillDetails(props.updateDetails).toStateJson())
  }, [])

  let changePaymentObj = (event, key) => {
    setPaymentObj((prevState)=>{
    return {...prevState, [key]: event.target.value}
    })
  }

  const makePayment = async () => {
    // try {
    //   const response = await payPartnerBillApi({...paymentObj, role_name: 'cp', user_id: props.updateDetails?.user_id, id: props.updateDetails?.id}).unwrap();
    //   props.updateShowState()
    //   toast.success("Payment done successfully")
    //   dispatch(updateQueryParams(selectedQueryParams));
    // } catch (error) {
    //   toast.error(error.data?.message || "Something went wrong!")
    // }
  }

  return <Modal className="modal-lg" show={props.updateDetails !== null} onHide={() => props.updateShowState()}>
    <Modal.Header closeButton>
      <Modal.Title>Payment to Electricity Bill</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <DetailsComponent data={electricityBillDetails} />
      <Row>
        <Col>
          <label htmlFor="amount_to_pay" className="form-label">Amount to Pay</label>
          <input
            id="amount_to_pay"
            value={paymentObj.amount_to_pay}
            onChange={(e) => changePaymentObj(e, 'amount_to_pay')}
            type="number"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter the amount to pay'
            aria-describedby='amount_to_pay_help'
          />
        </Col>
        <Col>
          {/* <label htmlFor="name" className="form-label">Payment Document</label>
          <input
            id="name"
            value={paymentObj.tally_transaction_number}
            onChange={(e) => changePaymentObj(e, 'tally_transaction_number')}
            type="text"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Payment Document No.'
            aria-describedby='name_help'
          /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <label htmlFor="reason" className="form-label">Reason</label>
          <textarea
            id="reason"
            value={paymentObj.reason}
            onChange={(e) => changePaymentObj(e, 'reason')}
            className="form-control form-control-sm font-size-12"
            placeholder='Reason'
            aria-describedby='reason_help'
          />
        </Col>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <button className='btn bg-danger text-white' onClick={()=> props.updateShowState()}>
        Close
      </button>
      <button className='btn bg-success text-white' onClick={()=> makePayment()}>
        Process Payment
      </button>
    </Modal.Footer>
  </Modal>
}

export default PaymentModal;
